module.exports = __webpack_public_path__ + "img/07.979d0229.jpg";